module.exports = __webpack_public_path__ + "img/cio.3f4542a3.png";